
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.517 20.121l3.369-3.364a3.832 3.832 0 000-5.403l-2.246-2.24A3.812 3.812 0 0029.936 8a3.817 3.817 0 00-2.707 1.114l-3.406 3.4 7.694 7.607zm-1.354 1.352l-7.693-7.607L8.283 28.033a.65.65 0 00-.191.451L8 35.342c-.005.36.29.658.652.658l6.836-.13a.651.651 0 00.449-.19l14.226-14.207zM30.003 6c1.513 0 2.973.59 4.057 1.674l2.265 2.259c2.234 2.233 2.234 5.88 0 8.112l-19.11 19.081a2.538 2.538 0 01-1.748.742L8.572 38C7.126 38 5.979 36.84 6 35.427l.093-6.914a2.539 2.539 0 01.745-1.762L25.942 7.674A5.73 5.73 0 0130.002 6z"}})])
          )
        }
      }
    